<div class="pedido-list pedido-pedido-list">
    <table class="table table-striped table-hover table-bordered" [id]="tableId">
        <thead>
            <tr>
                <th class="col-options"></th>
                <th class="col-badges text-center"></th>
                <th class="col-resultado-pedido text-center" title="Demonstração do Resultado do Pedido">D.R.P.</th>
                <th class="col-numero text-center">Número</th>
                <th class="col-numero-ecommerce text-center">Núm. E-commerce</th>
                <th class="col-numero-erp text-center">Núm. ERP</th>
                <th class="col-emissao text-center">Emissão</th>
                <th class="col-data-confirmacao text-center">Confirmação</th>
                <th class="col-quantidade-total text-right">Quantidade</th>
                <th class="col-quantidade-volumes-previstos text-right" title="Volumes Previstos">Vol. Previstos</th>
                <th class="col-valor-total text-right">Total</th>
                <th class="col-status text-center">Status</th>
                <th class="col-setor-gep text-center">Setor GEP</th>
                <th class="col-cliente">Cliente</th>
                <th class="col-classificacao-rap" title="{{KPI_RAP.nome}}">RAP</th>
                <th class="col-representante">Representante</th>
                <th class="col-motivo-reprovado">Motivo Reprovação</th>
                <th class="col-tabela-preco">Tabela de Preço</th>
                <th class="col-nome-campanha">Campanha</th>
                <th class="col-nome-condicao-pagamento">Condição de Pagamento</th>

                <th class="col-motivo-nao-liberado">Motivo Não Liberado</th>
                <th class="col-data-nao-liberado text-center">Data Não Liberado</th>
                <th class="col-venda-referenciada text-right">Venda Referenciada</th>
                <th class="col-lucro-liquido-nao-liberado text-right">Lucro Líquido Não Liberado</th>
                <th class="col-data-liberado text-center">Data Liberado</th>
                <th class="col-usuario-liberado">Usuário Liberado</th>
                <th class="col-justificativa-liberado">Justificativa Liberado</th>
            </tr>
        </thead>
        <tfoot *ngIf="total">
            <tr>
                <td colspan="8" class="text-center">
                    {{total.quantidadePedidos | decimalFormat: 1:0:0}} pedido(s)
                </td>
                <td class="col-quantidade-total text-right">
                    {{total.quantidadeTotal | decimalFormat: 1:0:0}}
                </td>
                <td class="col-quantidade-volumes-previstos text-right">
                    {{total.quantidadeVolumesPrevistos | decimalFormat: 1:0:0}}
                </td>                
                <td class="col-valor-total text-right">
                    {{total.valorTotal | currencyFormat: 1:2:2}}
                </td>
                <td class="col-status text-center"></td>
                <td class="col-setor-gep text-center"></td>
                <td class="col-cliente"></td>
                <td class="col-classificacao-faturamento-pretendida text-center"></td>
                <td class="col-representante"></td>                
                <td class="col-tabela-preco"></td>
                <td class="col-motivo-reprovado"></td>
                <td class="col-nome-campanha"></td>                          
                <td class="col-nome-condicao-pagamento"></td>                

                <td class="col-motivo-nao-liberado"></td>
                <td class="col-data-nao-liberado"></td>
                <td class="col-venda-referenciada"></td>
                <td class="col-lucro-liquido-nao-liberado"></td>
                <td class="col-data-liberado"></td>
                <td class="col-usuario-liberado"></td>
                <td class="col-justificativa-liberado"></td>                
            </tr>
        </tfoot>
    </table>         
</div>

<!-- Container para criar dinamicamente os badges na table -->
<ng-template #colBadgesContainer></ng-template>

<!-- Container para criar dinamicamente os badges dos tipos de vendas dos pedidos -->
<ng-template #tipoVendaBadgesContainer></ng-template>

<!-- Container para criar dinamicamente os badges dos status dos pedidos -->
<ng-template #statusBadgesContainer></ng-template>

<!-- Container para criar dinamicamente os badges dos setores GEPS dos pedidos -->
<ng-template #setorGepBadgesContainer></ng-template>

<!-- Modal de envio de e-mails -->
<sgt-pedido-email-modal
    idModal="pedidoEmailModal"
    #pedidoEmailModal>
</sgt-pedido-email-modal>

<!-- Modal de cancelamento -->
<sgt-pedido-cancelamento-modal
    (afterCancel)="afterCancel()"
    #pedidoCancelamentoModal>
</sgt-pedido-cancelamento-modal>

<!-- Modal para liberar pedidos -->
<sgt-pedido-liberar-modal
    (afterLiberar)="afterLiberar($event)"
    #pedidoLiberarModal>
</sgt-pedido-liberar-modal>